import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import useAuth from 'src/hooks/useAuth';
import ProcessoLookup from 'src/lookups/processo';
import { capitalizeFirstLetter } from 'src/utils/string';
import Checkbox from 'src/componentes/checkbox';
import { matchesSearch } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';

function InformacoesItemImpactado({ model, searchQuery }) {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const isVisible = (label) => matchesSearch(label, searchQuery);

  const labelProcessos = capitalizeFirstLetter(
    intl.formatMessage(
      { id: 'label.processos' },
      { processos: resources?.processos }
    )
  );
  const labelIncluirSubprocessos = capitalizeFirstLetter(
    intl.formatMessage(
      { id: 'incluirSubprocessos' },
      {
        processosfilhosplural: resources?.processosfilhosplural?.toLowerCase(),
      }
    )
  );

  const allLabels = [labelProcessos, labelIncluirSubprocessos].filter(Boolean);

  if (searchQuery && !allLabels.some((l) => isVisible(l))) return null;

  return (
    <CollapsibleSection
      title={intl.formatMessage(
        { id: 'labelInformacaoItemImpactado' },
        { impactado: resources?.processo }
      )}
      defaultOpen={true}
      forceOpen={!!searchQuery}
    >
      <Row>
        {isVisible(labelProcessos) && (
          <Col md={12}>
            <ProcessoLookup
              multi
              data={{ TipoId: 5 }}
              useClickToOpen={false}
              model={{
                label: labelProcessos,
                value: model.getModel('processos').value,
                requestChange: model.getModel('processos').requestChange,
              }}
            />
          </Col>
        )}
        {isVisible(labelIncluirSubprocessos) && (
          <Col md={12}>
            <Checkbox
              model={{
                label: labelIncluirSubprocessos,
                value: model.getModel('incluirSubprocessos').value,
                requestChange: model.getModel('incluirSubprocessos')
                  .requestChange,
              }}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
}

export default InformacoesItemImpactado;
